/* tslint:disable */
/* eslint-disable */
/* @relayHash f0dfc9289aee52fa702c2b6095bebc9b */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionBanQueryVariables = {
    userID: string;
};
export type ModerationActionBanQueryResponse = {
    readonly user: {
        readonly " $fragmentRefs": FragmentRefs<"ModerationActionBanContainer_user">;
    } | null;
};
export type ModerationActionBanQuery = {
    readonly response: ModerationActionBanQueryResponse;
    readonly variables: ModerationActionBanQueryVariables;
};



/*
query ModerationActionBanQuery(
  $userID: ID!
) {
  user(id: $userID) {
    ...ModerationActionBanContainer_user
    id
  }
}

fragment ModerationActionBanContainer_user on User {
  id
  status {
    ban {
      active
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userID"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "userID"
        } as any)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ModerationActionBanQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ModerationActionBanContainer_user"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ModerationActionBanQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "kind": "LinkedField",
                                    "name": "ban",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "active",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "f0dfc9289aee52fa702c2b6095bebc9b",
            "metadata": {},
            "name": "ModerationActionBanQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '901c8770f8281542a041780092493604';
export default node;
